import { module } from 'modujs';
import Plyr from 'plyr';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.playerElt = this.el.querySelector('.c-player_elt');
        this.player = new Plyr(this.playerElt);
    }

    pause(e) {
        if (e.way == 'leave') {
            if (this.player) {
                this.player.pause();
            }
        }
    }
}
